import { render, staticRenderFns } from "./errorMsg.vue?vue&type=template&id=2a737f38&scoped=true&"
import script from "./errorMsg.vue?vue&type=script&lang=js&"
export * from "./errorMsg.vue?vue&type=script&lang=js&"
import style0 from "./errorMsg.vue?vue&type=style&index=0&id=2a737f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../AppPlus/H5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a737f38",
  null
  
)

export default component.exports